import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { CheckoutSuccessData } from 'src/app/shared/model/checkout-success-data';
import { CheckoutService } from 'src/app/shared/services/checkout.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Api } from 'src/app/shared/enum/Api';
import { SelfAttendanceService } from 'src/app/shared/services/self-attendance.service';

@Component({
    selector: 'pme-pix-success',
    templateUrl: './pix-success.component.html',
    styleUrls: ['./pix-success.component.scss'],
    standalone: false
})
export class PixSuccessComponent implements OnInit, OnChanges {

  @Output() msgIsPixPaid = new EventEmitter<boolean>();

  productFamily: string;
  productName: string;
  valuePerMonth: string;
  totalValue: string;

  checkoutSuccessData: CheckoutSuccessData;
  interval: any;
  isPixPaid: boolean = false;
  timeExpired: boolean = false;
  expirationTime: number;
  submitting: boolean;

  constructor(
    public sessionStorageService: SessionStorageService,
    private checkoutService: CheckoutService,
    private snackBarService: SnackBarService,
    private httpService: HttpService,
    public dialog: MatDialog,
    private selfAttendanceService: SelfAttendanceService,
  ) {
    this.checkoutSuccessData = checkoutService.getLocalStorageCheckoutSuccessData();
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
   }

  ngOnInit(): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }

  ngOnChanges (): void {
    this.expirationTime = this.expirationTime && this.expirationTime > 0 ? this.expirationTime : (new Date(this.checkoutSuccessData.pixData?.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
  }

  copyContent() {
    navigator.clipboard.writeText(this.checkoutSuccessData.pixData.qrCode);
    this.snackBarService.openSnackBar('Código copiado');
  }

  redirectSuccess(){
    let validationData = JSON.parse(this.sessionStorageService.getCustomData('validationData'));
    document.location.href = environment.redirect_disconnect_sale + `cadastro/criar-senha?user=${validationData.email}`;
  }

  checkPurchaseIntegrationStatus(contractCode: string): Promise<string> {
    return lastValueFrom(this.httpService.post('eCommercePME/eCommerceAPI/checkPurchaseIntegrationStatus', Api.One_Portal,
      {
        'contractCode': contractCode
      }))
      .then(result => {
        return result.integrationStatus;
      });
  }

  openErrorIntegrationDialog(productIdentifier) {
    const data = DialogData.fromPreset("processingPurchase");
    const errorMessage = data.errorMessage;

    this.dialog.open(DialogAlertComponent, {
      disableClose: false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });
  }

  pixPaid() {
    this.interval = setInterval(() => this.consultRemittanceStatus(), this.checkoutSuccessData.pixData.remittanceConsultsInterval);
  }

  consultRemittanceStatus(): void {

    this.selfAttendanceService.getRemittanceStatus(this.checkoutSuccessData.pixData.txid).subscribe(
      (result) => {
        if (result.remittance?.status) {
          this.isPixPaid = true;
          clearInterval(this.interval);
          this.msgIsPixPaid.emit(true);
      }
    });
  }

  changePage() {
    this.timeExpired = !this.timeExpired;
    if (this.timeExpired) {
      clearInterval(this.interval);
    }
  }

  getPix2ndCopy() {
    this.submitting = true;
    this.selfAttendanceService.getPix2ndCopy(this.checkoutSuccessData.contract.provisioningParameters.businessId, this.checkoutSuccessData.contract.provisioningParameters.userId, this.checkoutSuccessData.contract.product.classificationIdentifier).subscribe(
      (selfAttendanceData) => {
        if (selfAttendanceData && selfAttendanceData.pixData) {
          selfAttendanceData.businessId = this.checkoutSuccessData.contract.provisioningParameters.businessId;
          selfAttendanceData.userId = this.checkoutSuccessData.contract.provisioningParameters.userId;

          this.checkoutSuccessData.pixData = selfAttendanceData.pixData;

          this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
          this.expirationTime = (new Date(selfAttendanceData.pixData.pixExpiryTime).getTime() - new Date().getTime()) / 1000;
          this.submitting = false;
          this.changePage();
        }
      },
      (error) => {
        console.error(error);
        this.submitting = false;
      }
    )
  }

}
